const navBar = document.getElementById('nav');

if (window.innerWidth < 500) {
    scroll(100, 100);
} else {
    scroll(500, 480);
}

function scroll(desktop = 736, mobile = 320) {
    window.addEventListener('scroll', function() {
        if (window.innerWidth >= 991) {
            if (this.scrollY >= desktop) {
                navBar.classList.add('fixed');

                if (navBar.classList.contains('default-white')) {
                    navBar.classList.remove('white');
                    navBar.classList.add('black');
                }
            } else {
                navBar.classList.remove('fixed');

                if (navBar.classList.contains('default-white')) {
                    navBar.classList.add('white');
                    navBar.classList.remove('black');
                }
            }
        } else {
            if (this.scrollY >= mobile) {
                navBar.classList.add('fixed');

                if (navBar.classList.contains('default-white')) {
                    navBar.classList.remove('white');
                    navBar.classList.add('black');
                }
            } else {
                navBar.classList.remove('fixed');

                if (navBar.classList.contains('default-white')) {
                    navBar.classList.add('white');
                    navBar.classList.remove('black');
                }
            }
        }
    });
}
